import { InvestorBankAccountsActionTypes } from './action-types';
import { BankAccountView, SortParamsArg } from 'models';

export const requestInvestorBankAccounts = () =>
  ({
    type: InvestorBankAccountsActionTypes.REQUEST_INVESTOR_BANK_ACCOUNTS,
  } as const);

export const requestInvestorBankAccountsSuccess = (
  bankAccounts: BankAccountView[]
) =>
  ({
    type: InvestorBankAccountsActionTypes.REQUEST_INVESTOR_BANK_ACCOUNTS_SUCCESS,
    payload: bankAccounts,
  } as const);

export const requestInvestorBankAccountsFailed = () =>
  ({
    type: InvestorBankAccountsActionTypes.REQUEST_INVESTOR_BANK_ACCOUNTS_FAILED,
  } as const);

export const setInvestorBankAccountsSortParams = (params: SortParamsArg) =>
  ({
    type: InvestorBankAccountsActionTypes.SET_SORT_PARAMS,
    payload: params,
  } as const);
